import {Injectable} from '@angular/core';
import {LoadingController, LoadingOptions} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoaderManagerService {

  private loader: HTMLIonLoadingElement | null = null;

  constructor(
    private readonly loadingCtrl: LoadingController
  ) {
  }


  /**
   * Mostrar icono de carga
   *
   */
  public async show(message: string = '') {

    if (this.loader) {
      return;
    }

    const loadingOptions: LoadingOptions = {
      spinner: 'circular',
      translucent: true,
    };

    if (message) {
      loadingOptions.message = message;
    }

    this.loader = await this.loadingCtrl.create(loadingOptions);
    await this.loader.present();
  }


  /**
   * Ocultar icono de carga
   *
   */
  public hide(delay: number = 100) {

    setTimeout(() => {

      if (!this.loader) {
        return;
      }

      this.loader.dismiss();
      this.loader = null;

    }, delay);

  }

}
